import type { AxiosInstance } from 'axios';

import { resolveQuantaApiUrl } from '@/config/quanta';

export const QUANTA_API_BASE_URL = resolveQuantaApiUrl(process.env.NEXT_PUBLIC_QUANTA_API_URL);

// Keep the authenticated Axios transport out of the signed-out welcome page.
// Delegate to the same instance: headers, cancellation, timeout and errors retain
// their Axios semantics. The module cache reuses the client across requests.
export const quantaApi: Pick<AxiosInstance, 'get' | 'post'> = {
  get: (async (...args: Parameters<AxiosInstance['get']>) => {
    const { quantaHttpClient } = await import('./quantaHttpClient');
    return quantaHttpClient.get(...args);
  }) as AxiosInstance['get'],
  post: (async (...args: Parameters<AxiosInstance['post']>) => {
    const { quantaHttpClient } = await import('./quantaHttpClient');
    return quantaHttpClient.post(...args);
  }) as AxiosInstance['post'],
};
